import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { LEAD_NOTE_CHANNELS } from '@src/shared/types/lead-note';
import { FILTER_COLOR } from './filter-colors';

export const leadChannelFilterConfig = createSimpleFilterConfig({
  facetName: 'channel',
  color: FILTER_COLOR.indigo,
  options: Object.values(LEAD_NOTE_CHANNELS).map((channel) => ({
    label: formatTextForDisplay(channel),
    value: channel,
  })),
});
